import { render } from "./m_mapserch.vue?vue&type=template&id=71632e4a&scoped=true"
import script from "./m_mapserch.vue?vue&type=script&lang=js"
export * from "./m_mapserch.vue?vue&type=script&lang=js"

import "./m_mapserch.vue?vue&type=style&index=0&id=71632e4a&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71632e4a"]])

export default __exports__